export const NON_WORKING_DAY_TYPE = {
  invalid: 0,
  delivery: 1,
  processing: 2,
  pickup: 3
};

export default { NON_WORKING_DAY_TYPE };
